import * as React from "react";
import {Button, Form, Table, Modal, Row, Col, Alert, Badge} from "react-bootstrap";
import { CreateOrderPosition } from "../../../../../stores";
import { formatMoney } from "../../../../../common/Formatting";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EditableText } from "../../../../../common/UI/EditableText";
import { makeMobileViewScreenshot } from "../../../../../common/UI/makeMobileViewScreenshot";
import { NotificationStore } from "../../../../../stores/NotificationStore"
import { AuthStore } from "../../../../../stores"


interface IProps {
    positions: CreateOrderPosition[];
    isOpened: boolean;
    closeModal: () => void;
    notificationStore: NotificationStore;
    authStore: AuthStore,
    managerName: string
}


export const MobileViewModal: React.StatelessComponent<IProps> = (props) => {

    const currentDate = new Date().toLocaleDateString("ru-RU", {day: "2-digit", month: "2-digit", year: "2-digit"})
    
    return <Modal show={props.isOpened} onHide={props.closeModal} className="modal-xs" >
        <Modal.Header closeButton>
            <Modal.Title className="w-100">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <span> Позиции заказа от {currentDate} </span>
                    <Button variant="primary" size="sm" onClick={() => { makeMobileViewScreenshot(props.notificationStore) }}> Скриншот </Button>
                </div>
            </Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <Row>
                <Col sm={12}>
                    Менеджер: <strong> {props.managerName?.trim() || props.authStore.name} </strong>
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    Количество позиций: <strong> {props.positions.length}</strong>
                </Col>
                <Col sm={6}>
                    Сумма заказа: <strong> {formatMoney(props.positions.reduce((a: number, b) => a + ((b.newCostSale || b.costSale) * b.count), 0))}</strong>
                </Col>
            </Row>
            <br />
            <Table bordered className="table-xxs mobile-table">
                <thead>
                    <tr>
                        <th>Бренд</th>
                        <th className={"text-center"}>Срок</th>
                        <th className={"text-center"}>Клиенту</th>
                        <th className={"text-center"}>Кол-во</th>
                        <th className={"text-center"}>Цена</th>
                        <th className={"text-center"}>Сумма</th>
                    </tr>
                </thead>
                <tbody>
                    {props.positions.map((item, index) => {
                        const costSale = item.newCostSale != null && item.newCostSale != 0 ? item.newCostSale : item.costSale;
                        
                        let refundInfo = <Badge variant="success" title={`Обратный выкуп ${item.refundDiscount === 0 ? 'без уценки' : 'c уценкой ' + item.refundDiscount + '%'}`}>
                                    {item.refundDiscount === 0 ? <FontAwesomeIcon icon="check"/> : item.refundDiscount}
                                </Badge>

                        if (item.isAllowDiscountRefund == null) {
                            refundInfo = <div></div>
                        } else {
                            if (!item.isAllowDiscountRefund) {
                                refundInfo = <Badge variant="warning" title="Обратный выкуп невозможен">
                                    <FontAwesomeIcon icon="times"/>
                                </Badge>
                            }
                        }
                        
                        
                        return [<tr key={1}>
                            <td>
                                {index + 1}. {' '} <strong>{item.brand}</strong>
                            </td>
                            <td className={"text-center"}>
                                {item.deliveryTimeString}<br/>
                                {refundInfo}
                            </td>
                            <td className={"text-center"}>
                                {item.isInUpdating ? <FontAwesomeIcon icon="spinner" /> : item.timeToRegionString}
                            </td>
                            <td className={"text-center"}>
                                {item.count}
                            </td>
                            <td className={"text-center"}>
                                {formatMoney(costSale)}
                            </td>
                            <td className={"text-center"}>
                                <strong>{formatMoney(costSale * item.count)}</strong>
                            </td>
                        </tr>,
                        <tr key={2}>
                            <td colSpan={6} style={{ borderBottom: (item.comment || '').isNullOrEmpty() ? "1px solid gray" : "" }}>
                                <EditableText
                                    text={item.description.length > 180 ? item.description.substring(0, 180) + "..." : item.description}
                                />
                            </td>
                        </tr>,
                        [(item.comment || '').isNullOrEmpty() ? [] : <tr>
                            <td colSpan={6} style={{ borderBottom: "1px solid gray" }}>
                                <small>
                                    <strong>Комментарий: </strong>
                                    {item.comment}
                                </small>
                            </td>
                        </tr>
                        ]
                        ];
                    })}
                </tbody>
            </Table>
            <Alert variant="warning">
                <a className="alert-link">Внимание!!! Данное Коммерческое предложение по цене и срокам действительно в течении текущего дня!!!</a>
            </Alert>

        </Modal.Body>
    </Modal >
}